<div (click)="close()" [class]="{'modal-overlay visible': settings.hasBackdrop, 'modal-overlay': !settings.hasBackdrop}">
    <div class="modal-content" (click)="isolate($event)">
      <ng-template #content></ng-template>
    </div>
</div>